import CancelIcon from './CancelIcon';

export default CancelIcon;
